import React from 'react';

import { Checkbox, FormControlLabel } from '@material-ui/core';
import RadioButtonCheckedRoundedIcon from '@material-ui/icons/RadioButtonCheckedRounded';
import RadioButtonUncheckedRoundedIcon from '@material-ui/icons/RadioButtonUncheckedRounded';

import { IMetaFormat } from '../../../../../../store/admin/roundFormats/store';

interface IProps {
  metaFormatToUpdate: IMetaFormat;
  onSaveMetaFormat: (format: IMetaFormat) => void;
}

export const OptionalFlightSection = (props: IProps) => {
  const { metaFormatToUpdate, onSaveMetaFormat } = props;

  const handleOnChange = (value: boolean) => () =>
    onSaveMetaFormat({ ...metaFormatToUpdate, considerFlights: value });

  return (
    <div>
      <p className="format-label">HOW IS THE CONTEST SET UP?</p>

      <div>
        <FormControlLabel
          className="round-subformat-checkbox override"
          classes={{ label: 'label' }}
          control={
            <Checkbox
              className="check-considered-flight"
              checked={metaFormatToUpdate.considerFlights}
              onChange={handleOnChange(true)}
              icon={<RadioButtonUncheckedRoundedIcon fontSize="large" />}
              checkedIcon={<RadioButtonCheckedRoundedIcon fontSize="large" />}
              value="on"
              color="primary"
            />
          }
          label="Players in each respective flight compete against one another"
        />
        <FormControlLabel
          className="round-subformat-checkbox override"
          classes={{ label: 'label' }}
          control={
            <Checkbox
              className="check-considered-flight"
              checked={!metaFormatToUpdate.considerFlights}
              onChange={handleOnChange(false)}
              icon={<RadioButtonUncheckedRoundedIcon fontSize="large" />}
              checkedIcon={<RadioButtonCheckedRoundedIcon fontSize="large" />}
              value="on"
              color="primary"
            />
          }
          label="Players in the entire field compete regardless of flight"
        />
      </div>
    </div>
  );
};
